(function () {
    'use strict';

    angular
        .module('app')
        .directive('folderBrowser', folderBrowser);

    folderBrowser.$inject = ['$window'];

    function folderBrowser($window) {
        // Usage:
        //     <folderBrowser></folderBrowser>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/folderbrowser/templates/folderbrowser.html',
            controller: 'folderbrowser',
            controllerAs: 'fb'
        };
        return directive;

        function link(scope, element, attrs) {
            $(element).prependTo(document.body);
        }
    }

})();